export default "__VITE_ASSET__nOF0nd_5__"